import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse } from '../models/util';
import { IUndefinedPart } from '../models';

export const getUndefinedParts = async (filters?: {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
  showOnlyUsedInOrders?: boolean;
}): Promise<IResponse<IUndefinedPart[]>> => {
  try {
    const { data } = await axios.get('/api/undefined-part-descriptions', {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getUndefinedParts failed');
    return Promise.reject(error);
  }
};

export const deleteUndefinedPart = async (id: number) => {
  try {
    const { data } = await axios.delete(`/api/undefined-part-descriptions/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteUndefinedPart failed');
    return Promise.reject(error);
  }
};

export const createUndefinedPart = async (description: string): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/undefined-part-descriptions`, { description });
    return data;
  } catch (error) {
    logError({ error, payload: description }, 'createUndefinedPart failed');
    return Promise.reject(error);
  }
};
